import Rellax from 'rellax';
import * as GLOBALS from './globals';
import { PolyfillImages } from './modules/polyfills';
import { InitAccordion } from './modules/accordion';
import { InitHeaderMenu } from './modules/navigation';
import AlertNotice from './modules/alert_notice';
import { InitNews } from './modules/news';
import { InitInstagramFeed } from './modules/instagram_feed';
import { InitContactForm } from './modules/contact_form';
import { InitNumberCounter } from './modules/anim_numbers';
import InitModals from './modules/modal';
import InitCookieByte from './modules/cookie-byte';
import InitForms from './modules/form';
import easydropdown from 'easydropdown';
import InitFilterSection from './modules/filter';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import SliderHero from './classes/slider-hero';

// Polyfill NodeList forEach for IE - remove after dropping support!
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const siteInitialization = () => {
    PolyfillImages();
    InitHeaderMenu();
    InitCookieByte();
    InitAccordion();
    InitFilterSection();
    InitNews();
    InitInstagramFeed();
    InitContactForm();
    InitNumberCounter();
    InitForms();
    InitModals();
    ImageGallery.init();
    MediaViewer.init();
    SliderHero.initAll();
    AlertNotice.init();

    // Initialize Parallax scrolling library (not on IE or anything below tablets)
    if (!window.document.documentMode && window.innerWidth > GLOBALS.BREAKPOINT_LG) {
        new Rellax('[data-rellax]');
    }

    // init easy dropdown and destroy all instances inside flatpickr
    easydropdown.all();
    const flatpickrInstances = document.querySelectorAll('.flatpickr-calendar select');
    flatpickrInstances.forEach((select) => {
        const edd = easydropdown(select);
        edd.destroy();
    });
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);